// src/constants/pricing.js
// New file: Centralizes price durations.

export const priceDurations = [
   { value: 'daily', ar: 'يوميًا', en: 'Daily' },
   { value: 'weekly', ar: 'أسبوعيًا', en: 'Weekly' },
   { value: 'monthly', ar: 'شهريًا', en: 'Monthly' },
];